export const inputOpenAnswerSize = 738

export const inputAnswerSize = 510
